document.addEventListener("DOMContentLoaded", function () {
  // Get relevant elements
  const materialOptions = document.querySelectorAll("input[name='Material']");
  const frameColorFieldset = document.querySelector("fieldset.js.product-form__input:nth-of-type(2)");
  const frameColorOptions = document.querySelectorAll("input[name='Frame Color']");
  const frameColorNALabel = document.querySelector("label[data-frame-color='NA']");
  const frameColorNA = document.querySelector("input[value='NA']");
  const frameColorBlack = document.querySelector("input[value='Black']");

  // Permanently hide NA
  if (frameColorNALabel) {
    frameColorNALabel.style.display = "none"; // Hide NA's label
  }

  // Function to hide the Frame Color fieldset
  function hideFrameColor() {
    frameColorFieldset.style.display = "none"; // Hide frame color options
    if (frameColorNA) {
      frameColorNA.checked = true; // Ensure NA is selected when hidden
    }
  }

  // Function to show the Frame Color fieldset
  function showFrameColor() {
    frameColorFieldset.style.display = "block"; // Show frame color options
    if (frameColorBlack) {
      frameColorBlack.checked = true; // Default to Black when visible
    }
  }

  // Handle material change logic
  function handleMaterialChange(selectedMaterial) {
    if (selectedMaterial === "Canvas Framed") {
      showFrameColor(); // Show frame color options for Canvas Framed
    } else {
      hideFrameColor(); // Hide frame color options for other materials
    }
  }

  // Initialize on page load
  const defaultMaterial = document.querySelector("input[name='Material']:checked").value;
  handleMaterialChange(defaultMaterial);

  // Add event listeners to Material options
  materialOptions.forEach((option) => {
    option.addEventListener("change", (event) => {
      handleMaterialChange(event.target.value);
    });
  });
});
